import React from "react";
import { Timeline as MUITimeline } from "@mui/lab";
import { timelineItemClasses } from "@mui/lab/TimelineItem";

type Props = {
  sx?: any;
  center?: boolean;
  children: React.ReactNode;
};

export const Timeline = (props: Props) => {
  return (
    <MUITimeline
      position={props.center ? "alternate" : "right"}
      sx={{
        [`& .${timelineItemClasses.root}:before`]: !props.center
          ? {
              flex: 0,
              padding: 0,
            }
          : null,
        ...props.sx,
      }}
    >
      {props.children}
    </MUITimeline>
  );
};
